import type { CrmTranslate } from './crm-copy';

/** Copy for the Real Estate pack's record extensions: media and portal publishing. */
export function createCrmRealEstateCopy(t: CrmTranslate) {
  return {
    realEstateMediaManager: {
      title: t('crm.realEstateMediaManager.title'),
      description: (entityType: string) =>
        t('crm.realEstateMediaManager.description', {
          values: { entityType },
        }),
      entityTypes: {
        properties: t('crm.realEstateMediaManager.entityTypes.property'),
        listings: t('crm.realEstateMediaManager.entityTypes.listing'),
      },
      actions: {
        uploadMedia: t('crm.realEstateMediaManager.actions.uploadMedia'),
        uploading: t('crm.realEstateMediaManager.actions.uploading'),
        makePrimary: t('crm.realEstateMediaManager.actions.makePrimary'),
      },
      labels: {
        primary: t('crm.realEstateMediaManager.labels.primary'),
        video: t('crm.realEstateMediaManager.labels.video'),
      },
      empty: {
        noMedia: t('crm.realEstateMediaManager.empty.noMedia'),
      },
      messages: {
        loadFailed: t('crm.realEstateMediaManager.messages.loadFailed'),
        uploadFailed: t('crm.realEstateMediaManager.messages.uploadFailed'),
        uploaded: t('crm.realEstateMediaManager.messages.uploaded'),
        primaryUpdateFailed: t('crm.realEstateMediaManager.messages.primaryUpdateFailed'),
        primaryUpdated: t('crm.realEstateMediaManager.messages.primaryUpdated'),
        deleteFailed: t('crm.realEstateMediaManager.messages.deleteFailed'),
        deleted: t('crm.realEstateMediaManager.messages.deleted'),
      },
    },
    portalPublishing: {
      title: t('crm.portalPublishing.title'),
      description: t('crm.portalPublishing.description'),
      actions: {
        validate: t('crm.portalPublishing.actions.validate'),
        publish: t('crm.portalPublishing.actions.publish'),
        refresh: t('crm.portalPublishing.actions.refresh'),
        unpublish: t('crm.portalPublishing.actions.unpublish'),
        retry: t('crm.portalPublishing.actions.retry'),
        openPortalListing: t('crm.portalPublishing.actions.openPortalListing'),
      },
      sections: {
        validation: t('crm.portalPublishing.sections.validation'),
        publications: t('crm.portalPublishing.sections.publications'),
        syncJobs: t('crm.portalPublishing.sections.syncJobs'),
      },
      labels: {
        completeness: (score: number) =>
          t('crm.portalPublishing.labels.completeness', {
            values: { score },
          }),
        publishable: t('crm.portalPublishing.labels.publishable'),
        blocked: t('crm.portalPublishing.labels.blocked'),
      },
      fallbacks: {
        noExternalId: t('crm.portalPublishing.fallbacks.noExternalId'),
        notSynced: t('crm.portalPublishing.fallbacks.notSynced'),
        portal: t('crm.portalPublishing.fallbacks.portal'),
      },
      empty: {
        noPublications: t('crm.portalPublishing.empty.noPublications'),
        noSyncJobs: t('crm.portalPublishing.empty.noSyncJobs'),
      },
      messages: {
        loadFailed: t('crm.portalPublishing.messages.loadFailed'),
        validateFailed: t('crm.portalPublishing.messages.validateFailed'),
        actionFailed: (action: string) =>
          t('crm.portalPublishing.messages.actionFailed', {
            values: { action },
          }),
        actionDone: (action: string) =>
          t('crm.portalPublishing.messages.actionDone', {
            values: { action },
          }),
      },
    },
  };
}
